import { Injectable } from '@angular/core';
import createYi, { IYiInstance, getRemoteOptions } from '@zip/yi-core';
import { environment } from 'src/environments/environment';
import { AuthService } from '~services/auth/auth.service';
import { ZipYiContext } from './zip-yi-context.enum';

@Injectable({
  providedIn: 'root',
})
export class ZipYiService {
  isZipYiEnabled = false;
  private yiInstance: IYiInstance;

  constructor(private authService: AuthService) {}

  async initialize() {
    const yiRemoteOptions = await getRemoteOptions(environment.zipYi.env, environment.zipYi.appId);
    this.isZipYiEnabled = yiRemoteOptions.nonOrdinaryJsEnabled;
    this.yiInstance = createYi(yiRemoteOptions);
    await this.yiInstance.loadScript();
    this.yiInstance.setContext(ZipYiContext.Loading);
    await this.yiInstance.createYiSession();
  }

  async setContext(contextName: string) {
    if (!this.yiInstance) {
      await this.initialize();
    }

    this.yiInstance.setContext(contextName, this.authService.customerId);
  }
}
